import { render } from "./IndicesView.vue?vue&type=template&id=c97a042e&scoped=true"
import script from "./IndicesView.vue?vue&type=script&lang=js"
export * from "./IndicesView.vue?vue&type=script&lang=js"

import "./IndicesView.vue?vue&type=style&index=0&id=c97a042e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c97a042e"]])

export default __exports__